import React, { useEffect } from "react"
import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import { TitlePageResponsiveIconSmall } from "../../../components/Titles/Titles"
import { GenericDropDown } from "../../../components/Dropdown/Dropdown"
import GetSpace from "../../../utils/space"
import Button, { ButtonIcon } from "../../../components/Button/Button"
import {
  faBellConcierge,
  faClose,
  faDollarSign,
  faFile,
  faFileSignature,
  faHashtag,
  faMoneyBill,
  faPercent,
} from "@fortawesome/free-solid-svg-icons"
import InputField from "../../../components/InputField/InputField"
import { useRegister } from "../../../hooks/Register/useRegister"
import { AwardEntity } from "../../../Objects/Awards/AwardEntity"
import { useGetAward } from "../../../hooks/Award/useGetAward"
import { useCreateAward } from "../../../hooks/Award/useCreateAward"
import { useSaveAward } from "../../../hooks/Award/useSaveAward"
import { useToggle } from "../../../hooks/useToggle"
import { ToggleComponet } from "../../../components/Toggle/ToggleComponet"
import { EMoneyConditionType } from "../../../Enum/EMoneyConditionType"
import THEME from "../../../configuration/Theme"
import { SIZE } from "../../../configuration/Sizes"
import { EEnableStatusType } from "../../../Enum/EEnableStatusType"
import { INPUT_SIZE } from "../../../configuration/InputSize"
import { EAutoType } from "../../../Enum/EAutoType"
import { useConfirmation } from "../../../context/useConfirmationContext"
import { useRemoveAward } from "../../../hooks/Award/useRemoveAward"
import Animate, { AnimationTypes } from "../../../components/Animate/Animate"
import ModalPortal from "../../../components/Modal/ModalPortal"
import { ViewRegister } from "../../../components/ViewRegister/ViewRegister"
import { useTranslation } from "react-i18next"
import { Permissions } from "../../../Enum/PermissionsType"
import { usePermission } from "../../../hooks/Permissions/usePermission"
import { CanView } from "../../../components/CanView/CanView"
import { CopyDraftAlert } from "../../../components/CopyDraftAlert/CopyDraftAlert"
import { useApplyAward } from "../../../hooks/Award/useApplyAward"
import { AwardApplyPopup } from "./AwardApplyPopup"
import { PopupHelpButton } from "../../../components/Help/PopupHelpButton"
import { AssociationsPopup } from "../../../components/Associations/AssociationsPopup"
import { customerMemory } from "../../../Objects/Memory/Memory"
import { resolveAwardAssociations } from "../../../components/Associations/associationResolvers"
import { useGetCustomer } from "../../../hooks/Costumer/useGetCustomer"

interface AwardPupopProbs {
  title: string
  award?: AwardEntity
  onClonse: () => void
  onCopy?: () => void
}

export const AwardPupop: React.FC<AwardPupopProbs> = ({ award, title, onClonse, onCopy }) => {
  const { t } = useTranslation("awards")

  const isCopiedDraft = award?.id === -1

  const [showAssociations, setShowAssociations] = React.useState(false)

  const canEdite = !usePermission(Permissions.CanEditeAwards)

  const { handleEnableRegister, handleDisableRegister, isRegisterEnable } = useRegister()

  const { handleGetAward } = useGetAward()

  const { setNewConfirmation } = useConfirmation()

  const { handleRemove } = useRemoveAward()

  const ValueConditionType = Object.mapEnumToStrings(EMoneyConditionType)

  const { selectedType, handleToggleSelection } = useToggle(
    award?.conditionType === EMoneyConditionType.FixedValue ? [ValueConditionType[0]] : [ValueConditionType[1]],
  )

  const valueIsAutomatic = Object.mapEnumToStrings(EAutoType)

  const { selectedType: selectedModeType, handleToggleSelection: handleToggleModeSelection } = useToggle(
    award?.isAutomatic === EAutoType.Auto ? [valueIsAutomatic[0]] : [valueIsAutomatic[1]],
  )

  const {
    name,
    description,
    status,
    minimumValue,
    countToWin,
    valueDiscountWhenWon,
    setIsAutomatic,
    setConditionType,
    handleNameChange,
    handlecountToWinChange,
    handleDescriptionChange,
    handleMinimumCoastChange,
    handleStatusChange,
    handleSubmitForm,
    handleInitialValue,
    handleValueWhenWon,
  } = useCreateAward()

  const { handleSavesAward } = useSaveAward()

  const { handleApplyAward, handleRemoveAwardApply } = useApplyAward()

  const { handleGetCostumer } = useGetCustomer()

  const [enableApplyPopup, setEnableApplyPopup] = React.useState(false)

  const [enableRemoveApplyPopup, setEnableRemoveApplyPopup] = React.useState(false)

  useEffect(() => {
    handleInitialValue(award)
  }, [award])

  const handleChangeAutoType = (e: string[]) => {
    setIsAutomatic(e[0] === valueIsAutomatic[0] ? EAutoType.Auto : EAutoType.NotAuto)
  }

  const handleChangeConditionType = (e: string[]) => {
    setConditionType(e[0] === ValueConditionType[0] ? EMoneyConditionType.FixedValue : EMoneyConditionType.Percentage)
    handleChangeType()
  }

  const handleChangeType = () => {
    handleValueWhenWon({
      target: { value: "" },
    } as React.ChangeEvent<HTMLInputElement>)
  }

  const handleTrySubmit = (event: React.FormEvent) => {
    event.preventDefault()
    const result = handleSubmitForm(award?.id)

    if ("errors" in result) {
      return
    }

    handleSavesAward(result, () => {
      onClonse()
      handleGetAward(() => {})
    })
  }

  const handleShowAssociations = async () => {
    await handleGetCostumer(() => {})

    setShowAssociations(true)
  }

  return (
    <ModalPortal>
      <div className={defaultStyle.overlay}>
        <Animate type={AnimationTypes.slideUpIn} duration="0.3s">
          <div className={defaultStyle.alert}>
            <TitlePageResponsiveIconSmall
              title={title}
              iconColor={THEME.colors.iconBGColor}
              icon={faBellConcierge}
              children={
                <div className={defaultStyle.ButtonsActions}>
                  <>
                    {award && award.id !== -1 && (
                      <div style={{ width: "100px", marginRight: "5px" }}>
                        <GenericDropDown
                          data={Object.mapEnumToStrings(EEnableStatusType, {
                            exclude: [EEnableStatusType.All],
                          })}
                          initialState={status}
                          disable={canEdite}
                          handlerFuncion={handleStatusChange}
                          descriptionKey="interactionDescriptions:pages.serivesDir.awards.awardPupop.select.select"
                        />

                        <GetSpace right={10} />
                      </div>
                    )}

                    <PopupHelpButton
                      helpKey="pages.serivesdir.awards.awardpupop.1"
                      variant="global"
                      title={t("helpPopup:global.award.title")}
                      description={t("helpPopup:global.award.description")}
                      bullets={t("helpPopup:global.award.bullets", { returnObjects: true }) as string[]}
                    />

                    <GetSpace right={5} />

                    <ButtonIcon
                      sizeNumber={SIZE.buttonCloseIconSize}
                      bgColor={THEME.colors.buttonBGCloseColor}
                      iconColor={THEME.colors.buttonFGCloseColor}
                      icon={faClose}
                      onClick={onClonse}
                      size="small"
                      descriptionKey="interactionDescriptions:pages.serivesDir.awards.awardPupop.button.onClonse"
                    />
                  </>
                </div>
              }
            />

            {isCopiedDraft && <CopyDraftAlert />}

            <GetSpace top={5} />

            <form onSubmit={handleTrySubmit}>
              <div className="p-2">
                <ToggleComponet
                  canSelectType={true}
                  disable={canEdite}
                  selectedType={selectedModeType}
                  valuesToggle={valueIsAutomatic}
                  handleChangeType={handleChangeAutoType}
                  handleToggleSelection={handleToggleModeSelection}
                  descriptionKey="interactionDescriptions:pages.serivesDir.awards.awardPupop.toggle.toggle"
                />

                <GetSpace top={5} />

                <ToggleComponet
                  canSelectType={true}
                  selectedType={selectedType}
                  disable={canEdite}
                  valuesToggle={ValueConditionType}
                  handleChangeType={handleChangeConditionType}
                  handleToggleSelection={handleToggleSelection}
                  descriptionKey="interactionDescriptions:pages.serivesDir.awards.awardPupop.toggle.toggle2"
                />

                <div className={defaultStyle.divisionBar}></div>

                <InputField
                  maxLength={INPUT_SIZE.AWARD.name}
                  type="text"
                  placeholder={t("label_person_name_place_holder")}
                  onInvalidMessage={t("label_person_name_onInvalidMessage")}
                  icon={faFileSignature}
                  value={name}
                  disable={canEdite}
                  onChange={handleNameChange}
                  required
                  descriptionKey="interactionDescriptions:pages.serivesDir.awards.awardPupop.input.personNamePlaceHolder"
                />

                <GetSpace top={10} />

                <InputField
                  maxLength={INPUT_SIZE.AWARD.countToWin}
                  type="number"
                  placeholder={t("label_person_amount_consume_place_holder")}
                  onInvalidMessage={t("label_person_amount_consume_onInvalidMessage")}
                  icon={faHashtag}
                  value={countToWin}
                  disable={canEdite}
                  onChange={handlecountToWinChange}
                  required
                  descriptionKey="interactionDescriptions:pages.serivesDir.awards.awardPupop.input.personAmountConsumePlaceHolder"
                />

                <GetSpace top={10} />

                <InputField
                  maxLength={INPUT_SIZE.AWARD.minimumValue}
                  type="number"
                  placeholder={t("label_person_min_consume_place_holder")}
                  onInvalidMessage={t("label_person_min_consume_onInvalidMessage")}
                  icon={faMoneyBill}
                  disable={canEdite}
                  value={minimumValue}
                  onChange={handleMinimumCoastChange}
                  required
                  descriptionKey="interactionDescriptions:pages.serivesDir.awards.awardPupop.input.personMinConsumePlaceHolder"
                />

                <GetSpace top={10} />

                <InputField
                  maxLength={INPUT_SIZE.AWARD.description}
                  type="text"
                  placeholder={t("label_person_description_place_holder")}
                  onInvalidMessage={t("label_person_description_onInvalidMessage")}
                  icon={faFile}
                  value={description}
                  disable={canEdite}
                  onChange={handleDescriptionChange}
                  descriptionKey="interactionDescriptions:pages.serivesDir.awards.awardPupop.input.personDescriptionPlaceHolder"
                />

                <GetSpace top={10} />

                <InputField
                  maxLength={
                    selectedType[0] === ValueConditionType[0]
                      ? INPUT_SIZE.AWARD.valueDiscountWhenWon
                      : INPUT_SIZE.AWARD.valueDiscountWhenWonPercent
                  }
                  type="number"
                  required
                  onInvalidMessage={
                    selectedType[0] === ValueConditionType[0]
                      ? t("label_person_fixed_onInvalidMessage")
                      : t("label_person_percentage_onInvalidMessage")
                  }
                  placeholder={
                    selectedType[0] === ValueConditionType[0]
                      ? t("label_person_fixed_place_holder")
                      : t("label_person_percentage_place_holder")
                  }
                  icon={selectedType[0] === ValueConditionType[0] ? faDollarSign : faPercent}
                  value={valueDiscountWhenWon.toString()}
                  onChange={handleValueWhenWon}
                  disable={canEdite}
                  descriptionKey="interactionDescriptions:pages.serivesDir.awards.awardPupop.input.personFixedPlaceHolder"
                />

                <GetSpace top={5} />
              </div>

              <div className={defaultStyle.divisionBar}></div>

              <div className={defaultStyle.buttonsController}>
                <CanView permission={Permissions.CanEditeAwards}>
                  <>
                    <Button
                      label={t("buttons:button_save")}
                      typeButton="submit"
                      type="primary"
                      size="medium"
                      bgColor={THEME.colors.buttonBGSaveColor}
                      descriptionKey="interactionDescriptions:pages.serivesDir.awards.awardPupop.button.save"
                    />

                    <GetSpace right={5} />
                  </>
                </CanView>

                {award && award.id !== -1 && (
                  <>
                    <Button
                      label={t("buttons:button_register")}
                      typeButton="button"
                      type="primary"
                      size="medium"
                      bgColor={THEME.colors.buttonBGRegisterColor}
                      onClick={handleEnableRegister}
                      descriptionKey="interactionDescriptions:pages.serivesDir.awards.awardPupop.button.register"
                    />

                    <GetSpace right={5} />

                    <Button
                      label={t("buttons:button_view_associations")}
                      typeButton="button"
                      type="primary"
                      size="medium"
                      bgColor={THEME.colors.buttonBGPlusColor}
                      onClick={handleShowAssociations}
                      descriptionKey="interactionDescriptions:pages.serivesDir.awards.awardPupop.button.viewAssociations"
                    />

                    <CanView permission={Permissions.CanEditeAwards}>
                      <>
                        {onCopy && (
                          <>
                            <GetSpace right={5} />

                            <Button
                              label={t("buttons:button_copy")}
                              typeButton="button"
                              type="primary"
                              size="medium"
                              bgColor={THEME.colors.buttonBGPlusColor}
                              onClick={onCopy}
                              descriptionKey="interactionDescriptions:pages.serivesDir.awards.awardPupop.button.copy"
                            />
                          </>
                        )}

                        <GetSpace right={5} />

                        <Button
                          label={t("buttons:button_remove")}
                          typeButton="button"
                          type="primary"
                          size="medium"
                          iconColor={THEME.colors.buttonFGRemoveColor}
                          bgColor={THEME.colors.buttonBGRemoveColor}
                          onClick={() =>
                            setNewConfirmation(
                              t("general:label_title_remove"),
                              t("general:label_description_remove"),
                              async () => {
                                await handleRemove(award!, () => handleGetAward(onClonse))
                              },
                            )
                          }
                          descriptionKey="interactionDescriptions:pages.serivesDir.awards.awardPupop.button.remove"
                        />
                      </>
                    </CanView>
                  </>
                )}

                {award && award.id !== -1 && (
                  <CanView permission={Permissions.CanEditeAwards}>
                    <Button
                      label={t("buttons:button_apply")}
                      typeButton="button"
                      type="primary"
                      size="medium"
                      bgColor={THEME.colors.buttonBGRegisterColor}
                      onClick={() => setEnableApplyPopup(true)}
                      descriptionKey="interactionDescriptions:pages.serivesDir.awards.awardPupop.button.apply"
                    />

                    <GetSpace right={5} />

                    <Button
                      label={t("button_remove_apply_automatic")}
                      typeButton="button"
                      type="primary"
                      size="medium"
                      bgColor={THEME.colors.buttonBGCloseColor}
                      onClick={() => setEnableRemoveApplyPopup(true)}
                      descriptionKey="interactionDescriptions:pages.serivesDir.awards.awardPupop.button.removeApplyAutomatic"
                    />
                  </CanView>
                )}
              </div>
            </form>

            {isRegisterEnable && award && (
              <ViewRegister id={award.id} typeEntity="AwardEntityId" onClose={handleDisableRegister} />
            )}

            {showAssociations && award && (
              <AssociationsPopup
                title={t("general:label_related_title", { name: award.name })}
                emptyMessage={t("general:label_related_empty")}
                onClose={() => setShowAssociations(false)}
                items={resolveAwardAssociations(award, customerMemory.listData)}
              />
            )}

            {enableApplyPopup && award && (
              <AwardApplyPopup
                title={t("label_title_apply_automatic")}
                actionLabel={t("buttons:button_apply")}
                helpKey="pages.serivesdir.awards.awardpupop.2"
                helpTitle={t("helpPopup:sections.awards.applyAutomatic.title")}
                helpDescription={t("helpPopup:sections.awards.applyAutomatic.description")}
                helpBullets={t("helpPopup:sections.awards.applyAutomatic.bullets", { returnObjects: true }) as string[]}
                onClose={() => setEnableApplyPopup(false)}
                onConfirm={async (request) => {
                  await handleApplyAward(award.id, request, () => {
                    handleGetAward(() => {})
                    setEnableApplyPopup(false)
                  })
                }}
              />
            )}

            {enableRemoveApplyPopup && award && (
              <AwardApplyPopup
                title={t("label_title_remove_apply_automatic")}
                actionLabel={t("button_remove_apply_automatic")}
                helpKey="pages.serivesdir.awards.awardpupop.3"
                helpTitle={t("helpPopup:sections.awards.removeAutomatic.title")}
                helpDescription={t("helpPopup:sections.awards.removeAutomatic.description")}
                helpBullets={
                  t("helpPopup:sections.awards.removeAutomatic.bullets", { returnObjects: true }) as string[]
                }
                onClose={() => setEnableRemoveApplyPopup(false)}
                onConfirm={async (request) => {
                  await handleRemoveAwardApply(award.id, request, () => {
                    handleGetAward(() => {})
                    setEnableRemoveApplyPopup(false)
                  })
                }}
              />
            )}
          </div>
        </Animate>
      </div>
    </ModalPortal>
  )
}
